export default __webpack_public_path__ + "static/media/vero-copilot-logo.234d86b3.svg";